/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { Provider } from 'react-redux';
import React, { createContext } from 'react';
import ReactDOM from 'react-dom';
import { store, persistor, history } from './services/configureStore';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import { LayoutSplashScreen } from './_psb';

import 'socicon/css/socicon.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './_psb/_assets/fonts/line-awesome/css/line-awesome.css';
import './_psb/_assets/fonts/flaticon/flaticon.css';
import './_psb/_assets/fonts/flaticon2/flaticon.css';
// import 'bootstrap/dist/css/bootstrap.min.css'
// import './assets/css/plugins.css'
// import './assets/css/style.css'
// import './cutom.css'
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter } from 'react-router-dom';
import Cookie from 'js-cookie';

/* const context = createContext(null)
 */ const { PUBLIC_URL } = process.env;

if (Cookie.get('lang') === 'en') {
  document.getElementsByTagName('html')[0].setAttribute('lang', 'en');

  require('bootstrap/dist/css/bootstrap.min.css');

  require('./assets/css/plugins.css');
  require('./assets/css/style.css');
  require('./styles/css/style.css');
  require('./cutom.css');
} else {
  document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');

  require('bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css');
  require('bootstrap-v4-rtl/dist/js/bootstrap.min.js');
  require('./styles/css/style.css');
  require('./styles/css/rtl.css');
  require('./assets/css/plugins.css');
  require('./assets/css/style.css');
  require('./assets/css/rtl.css');
  require('./cutom.css');
}
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        <App />
      </PersistGate>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
